const React = require('react');
const createReactClass = require('create-react-class');
const _ = require('lodash');
const FuzzyReaction = require('../../bootstrap').FuzzyReaction;
const Fz = FuzzyReaction.require('components', 'Row', 'Column', 'Table', 'Filter', 'Button', 'PaginatedButtons', 'PerPageSelector');
const ResourceActions = FuzzyReaction.require('actions', 'ResourceActions').ResourceActions;

const MetaStore = require('../../stores/MetaStore');
const CastManagementMixin = require('../cast-library/components/CastManagementMixin');

/**
 * The Users list page view component
 *
 * @type {*|Function}
 */
const SongPlays = createReactClass({
    displayName: 'SongPlays',
    mixins: [CastManagementMixin],

    getInitialState: function () {
        return {
            currentPageData: [],
            workingResource: {},
            openDeactivateModal: false

        }
    },

    resource: new ResourceActions('meta/stats'),

    getOptions: {
        modifiers: {
            filters: {
                month_start: new Date().getMonth() + 1,
                month_end: new Date().getMonth() + 1,
                year: new Date().getFullYear()
            }
        },
        dataNode: 'data'
    },

    months: ['January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ],

    months_end: [],

    _onChange: function () {

        this.monthStartFilters();

        this.setState({
            currentPageData: MetaStore.getResourceListData()
        });
    },

    requestTableData: function (modifiers) {
        // Clear sorts when a new sort param is set
        if (typeof modifiers !== 'undefined' && modifiers.hasOwnProperty('sort')) {
            delete this.getOptions.modifiers.sort;
        }

        // Merge modifiers with already present ones
        this.getOptions.modifiers = _.mergeWith(this.getOptions.modifiers, modifiers, {});
        this.resource.listResource(this.getOptions);
    },

    componentDidMount: function () {
        this.requestTableData();

        MetaStore.addChangeListener(this._onChange);
    },

    componentWillUnmount: function () {
        MetaStore.removeChangeListener(this._onChange);
    },

    tableKeys: {
        'Track Title': 'title',
        'Track Details': 'duration',
        'Marketing Label': 'marketing_label',
        '# Plays This Month': 'play_count'
    },

    handleAction: function (action, resource) {
        switch (action) {
            case 'sort':
                this.requestTableData(resource);
                break;
            case 'export':
                window.open(MetaStore.getExportUrl(), '_blank');
                break;
        }
    },

    monthStartFilters: function () {
        const monthFilters = {};
        const month_end_filter = [];
        const actual_month = this.getOptions.modifiers.filters.month_start - 1;
        this.months.forEach(function (month_start, index) {
            if (index >= actual_month) {
                month_end_filter.push(month_start);
            }
            monthFilters[month_start] = {
                month_start: index + 1
            };
        });
        this.months_end = month_end_filter;
        return monthFilters;
    },

    monthEndFilters: function () {
        const months_start = this.months;
        const monthFilters = {};
        this.months_end.forEach(function (month_end) {
            monthFilters[month_end] = {
                month_end: months_start.indexOf(month_end) + 1
            };
        });

        return monthFilters;
    },

    yearFilters: function () {
        const currentYear = new Date().getFullYear();
        const lower = currentYear - 3;
        const upper = currentYear + 3;

        const yearFilters = {};
        for (let i = lower; i <= upper; i++) {
            yearFilters[i.toString()] = {
                year: i.toString()
            };
        }

        return yearFilters;
    },

    render: function () {
        const options = {
            actionableRows: false,
            actionsCallback: this.handleAction,
            hideSpinner: true,
            sortable: ['title', 'duration', 'marketing_label', 'play_count'],
            emptyText: 'No report available.',
            mutators: {
                duration: function (duration, track) {
                    if (typeof track.artist === 'undefined') {
                        return;
                    }

                    return (
                        <div className="song-play-track">
                            <div className="left-column float-left">
                                <p>{track.title}</p>
                                <p>{track.album}</p>
                                <p>{track.artist}</p>
                            </div>
                            <div className="right-column float-right">
                                <p>{this.toMinutesString(track.duration)}</p>
                            </div>
                        </div>
                    )
                }.bind(this)
            }
        };

        return (
            <div id="page-wrapper">
                <div id="page-content">
                    <div id="content"/>
                    <Fz.Row classes="align-items-center">
                        <Fz.Column grid="lg" size="4">
                            <h1 className="page-header">Song Play Reports</h1>
                        </Fz.Column>

                        <Fz.Column grid="lg" size="2" classes="export-song-report">
                            <Fz.Button action="export" text="Export to CSV" handleAction={this.handleAction}
                                       mods={['primary', 'float-right']}/>
                        </Fz.Column>

                        <Fz.Column grid="lg" size="2">
                            <Fz.Filter filters={this.monthStartFilters()}
                                       label={"Selected Start Month: " + this.months[this.getOptions.modifiers.filters.month_start - 1]}
                                       actionMethod={this.requestTableData}/>
                        </Fz.Column>

                        <Fz.Column grid="lg" size="2">
                            <Fz.Filter filters={this.monthEndFilters()}
                                       label={"Selected End Month: " + this.months[this.getOptions.modifiers.filters.month_end - 1]}
                                       actionMethod={this.requestTableData}/>
                        </Fz.Column>

                        <Fz.Column grid="lg" size="2">
                            <Fz.Filter filters={this.yearFilters()}
                                       label={"Selected Year: " + this.getOptions.modifiers.filters.year}
                                       actionMethod={this.requestTableData}/>
                        </Fz.Column>
                    </Fz.Row>

                    <Fz.Row>
                        <Fz.Column grid="lg" size="12">
                            <Fz.Table data={this.state.currentPageData}
                                      dataKeys={this.tableKeys}
                                      title={'Song Plays'} options={options}/>

                            <Fz.PaginatedButtons actionMethod={this.requestTableData}/>

                            <Fz.PerPageSelector actionMethod={this.requestTableData}/>
                        </Fz.Column>
                    </Fz.Row>
                </div>
            </div>
        )
    },
});

module.exports = SongPlays;
